import ChevronIcon from 'assets/chevron-black.svg?react'
import clsx from 'clsx'

import classes from './index.module.scss'

interface Props {
  classNames?: {
    active?: string
    root?: string
  }
  isRotated: boolean
  rotationDegrees?: '-90' | '90' | '180'
  size?: string
}

export const RotatingChevronIcon = ({
  classNames = {},
  isRotated,
  rotationDegrees = '180',
  size
}: Props) => {
  const styles: any = {}
  if (size) {
    styles.width = size
    styles.height = size
  }
  return (
    <ChevronIcon
      className={clsx(classNames.root, classes.root, {
        [classes.active]: isRotated,
        [classNames.active]: isRotated,
        [classes.half]: rotationDegrees === '90',
        [classes.halfReverse]: rotationDegrees === '-90',
        [classes.full]: rotationDegrees === '180'
      })}
      style={styles}
    />
  )
}
